unit UClockInForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UMainConfig, Types,
  Vcl.Grids, WEBLib.Grids, WEBLib.Buttons, UessentialHelper, UFakList,
  UTaetList, UStampModel, UClockEditForm, UKstList, UFakParaModel, UMatList;

type
  TClockInForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlData: TPanel;
    cbbClockIn: TComboBox;
    WebLabel1: TLabel;
    btnClockIn: TBitBtn;
    lblDate: TLabel;
    tmrClock: TTimer;
    lblTime: TLabel;
    pnlFak: TPanel;
    WebLabel2: TLabel;
    cbbFak: TComboBox;
    WebLabel3: TLabel;
    edtFakFind: TEdit;
    pnlData1: TPanel;
    lblDate1: TLabel;
    lblTime1: TLabel;
    pnlKOGE: TPanel;
    btnKO: TBitBtn;
    btnGE: TBitBtn;
    pnlPAPE: TPanel;
    btnPA: TBitBtn;
    btnPE: TBitBtn;
    pnlDADE: TPanel;
    btnDA: TBitBtn;
    btnDE: TBitBtn;
    pnlKAKE: TPanel;
    btnKA: TBitBtn;
    btnKE: TBitBtn;
    pnlTaet: TPanel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    cbbTaet: TComboBox;
    edtTaetFind: TEdit;
    pnlKst: TPanel;
    WebLabel4: TLabel;
    WebLabel7: TLabel;
    cbbKst: TComboBox;
    edtKstFind: TEdit;
    pnlMat: TPanel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    cbbMat: TComboBox;
    edtMenge: TEdit;
    procedure btnBackClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure tmrClockTimer(Sender: TObject);
    procedure btnClockInClick(Sender: TObject);
    procedure cbbClockInChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure edtFakFindChange(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    procedure clockInButtonClick(Sender: TObject);
    procedure cbbTaetChange(Sender: TObject);
    procedure cbbFakChange(Sender: TObject);
    [Async]
    procedure lblDateClick(Sender: TObject); async;
    procedure edtTaetFindChange(Sender: TObject);
    procedure edtKstFindChange(Sender: TObject);
    procedure edtMengeChange(Sender: TObject);
    procedure edtMengeKeyPress(Sender: TObject; var Key: Char);
  private
    { Private-Deklarationen }
    FMainConfig: TMainConfig;
    FOnPropertyChanged: TCallback;
    FFakList: TFakList;
    FTaetList: TTaetList;
    FDefBuArts: TStringList;
    FTimePoint: TDateTime;
    FKstList: TKstList;
    FPara: TFakParaModel;
    FMatList: TMatList;
    FStamp: TStampModel;
    FFakStamp: TStampModel;
    FKoAndFak: Boolean;
    function CheckMask: Boolean;
    function GetMask: TStampModel;
    procedure AnalyzeDefBuArts;
    procedure CalcPanelHeight;
    procedure cbbClockInFill;
    procedure cbbFakFill(Sender: TObject);
    procedure cbbKstFill(Sender: TObject);
    procedure cbbMatFill(Sender: TObject);
    procedure cbbTaetFill(Sender: TObject);
    procedure CreateButtons;
    procedure DisableBuArts(status: string);
    procedure DisableButtons(status: string);
    procedure DisableDefBuArt(index: Integer);
    procedure DisableDefBuArts;
    procedure DisableFakBuArt;
    procedure Error(Sender: TObject; AMsg: string);
    procedure GetLastFakStamp;
    procedure GetLastFak;
    procedure GetStatus;
    procedure ParaCallback(Sender: TObject);
    procedure PropertyChanged;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetFakList(const Value: TFakList);
    procedure SetTaetList(const Value: TTaetList);
    procedure SetDefBuArts(const Value: TStringList);
    procedure SetTimePoint(const Value: TDateTime);
    procedure SetKstList(const Value: TKstList);
    procedure SetPara(const Value: TFakParaModel);
    procedure SetMatList(const Value: TMatList);
  public
    { Public-Deklarationen }
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property FakList: TFakList read FFakList write SetFakList;
    property TaetList: TTaetList read FTaetList write SetTaetList;
    property DefBuArts: TStringList read FDefBuArts write SetDefBuArts;
    property TimePoint: TDateTime read FTimePoint write SetTimePoint;
    property KstList: TKstList read FKstList write SetKstList;
    property Para: TFakParaModel read FPara write SetPara;
    property MatList: TMatList read FMatList write SetMatList;
  protected procedure LoadDFMValues; override; end;

var
  ClockInForm: TClockInForm;

implementation

uses
  UGridHelper, UFakModel;

{$R *.dfm}
{ TClockInForm }

procedure TClockInForm.AnalyzeDefBuArts;
var
  i: Integer;
  s: string;
begin
  Self.DefBuArts.Clear;
  for i := 0 to cbbClockIn.Items.Count - 1 do
  begin
    s := cbbClockIn.Items[i];
    if Length(s) >= 2 then
    begin
      if (s[1] = 'B') and (s[2] in ['1' .. '9']) then
        Self.DefBuArts.Add(s[2]);
    end;
  end;
end;

procedure TClockInForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TClockInForm.btnClockInClick(Sender: TObject);
var
  stamp: TStampModel;
  stamp1: TStampModel;
  procedure Callback(Sender: TObject);
  var
    st: TStampModel;
  begin
    if Sender is TStampModel then
    begin
      st := Sender as TStampModel;
      if st.Result.ResultValue then
      begin
        Self.PropertyChanged;
        if stamp1 <> nil then
        begin
          stamp1.Insert(Self.MainConfig.Uri);
          stamp1 := nil;
        end
        else
          Self.Close;
      end
      else
        Self.Error(Sender, st.Result.ResultMessage);
    end
    else
      Close;
  end;

  procedure HandleError(Sender: TObject; AMsg: string);
  begin
    Self.Error(Sender, AMsg);
  end;

begin
  stamp1 := nil;
  Self.MainConfig.TimerReset;
  if Self.CheckMask then
  begin
    stamp := Self.GetMask;
    stamp.OnPropertyChanged := Callback;
    stamp.OnError := HandleError;
    if (stamp.Art = 'KO') and (stamp.Fak <> nil) and (stamp.Fak.Id > 0) then
    begin
      stamp1 := Self.GetMask;
      stamp1.Art := 'AA';
      stamp1.Zeitpunkt := stamp.Zeitpunkt;
      stamp.Fak := TFakModel.Create;
      stamp1.OnPropertyChanged := Callback;
      stamp1.OnError := HandleError;
    end;
    stamp.Insert(Self.MainConfig.Uri);
  end;
end;

procedure TClockInForm.CalcPanelHeight;
var
  default: Integer;
begin
  default := 125;
  if pnlKst.Visible then
  begin
    pnlKst.Top := default;
    default := default +pnlKst.Height;
  end;
  if pnlFak.Visible then
  begin
    pnlFak.Top := default;
    default := default +pnlFak.Height;
  end;
  if pnlTaet.Visible then
  begin
    pnlTaet.Top := default;
    default := default +pnlTaet.Height;
  end;
  if pnlMat.Visible then
  begin
    pnlMat.Top := default;
    default := default +pnlMat.Height;
  end;
  btnClockIn.Top := default;
  pnlData.Height := default +btnClockIn.Height + 16;
  Self.WebFormResize(Self);
end;

procedure TClockInForm.cbbClockInChange(Sender: TObject);
begin
  if Self.MainConfig <> nil then
    Self.MainConfig.TimerReset;
  if UpperCase(copy(cbbClockIn.Text, 1, 2)) = 'AA' then
  begin
    pnlFak.Visible := true;
    pnlTaet.Visible := Self.Para.TaetVerw;
    pnlMat.Visible := false;
    edtTaetFind.Text := '';
    Self.FakList.GetAll(Self.MainConfig.Uri, edtFakFind.Text);
  end
  else if UpperCase(copy(cbbClockIn.Text, 1, 2)) = 'KO' then
  begin
    pnlFak.Visible := true;
    pnlTaet.Visible := Self.Para.TaetVerw;
    pnlMat.Visible := false;
    edtTaetFind.Text := '';
    FKoAndFak := true;
    Self.FakList.GetAll(Self.MainConfig.Uri, edtFakFind.Text);
  end
  else if UpperCase(copy(cbbClockIn.Text, 1, 2)) = 'VM' then
  begin
    pnlFak.Visible := true;
    pnlTaet.Visible := false;
    pnlMat.Visible := true;
    edtMenge.Text := '';
    Self.FakList.GetAll(Self.MainConfig.Uri, edtFakFind.Text);
    Self.MatList.GetAll(Self.MainConfig.Uri);
  end
  else
  begin
    pnlFak.Visible := false;
    pnlTaet.Visible := false;
    pnlMat.Visible := false;
  end;
  Self.CalcPanelHeight;
end;

procedure TClockInForm.cbbClockInFill;
var
  i: Integer;
  s: string;
begin
  cbbClockIn.Items.Clear;
  for i := 0 to Self.MainConfig.ClockInConfig.List.Count - 1 do
  begin
    s := Self.MainConfig.ClockInConfig.List[i];
    s := DecodeClockInStr(s);
    cbbClockIn.Items.Add(Cut(s));
    cbbClockIn.Items.Add(Cut(s));
  end;
  if pnlKst.Visible then
    cbbClockIn.Items.Add('KW - Kostenstellenwechsel');
  if Self.Para.MengenVerw and Self.MainConfig.CommonConfig.WorkOrderTimes then
    cbbClockIn.Items.Add('VM - Verbrauchsmaterial');
  Self.CreateButtons;
  Self.GetStatus;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
end;

procedure TClockInForm.cbbFakChange(Sender: TObject);
var
  i, fakId: Integer;
begin
  if pnlTaet.Visible then
  begin
    fakId := 0;
    i := Self.FakList.IndexOf(cbbFak.Text);
    if i >= 0 then
      fakId := Self.FakList.Items[i].Id;
    Self.TaetList.GetAll(Self.MainConfig.Uri, fakId, edtTaetFind.Text);
  end;
  Self.MainConfig.TimerReset;
end;

procedure TClockInForm.cbbFakFill(Sender: TObject);
var
  i: Integer;
begin
  if Sender is TFakList then
  begin
    Self.FakList := Sender as TFakList;
    cbbFak.Items.Clear;
    for i := 0 to Self.FakList.Count - 1 do
      cbbFak.Items.Add(Self.FakList.Items[i].ToString);
    if Self.MainConfig.CommonConfig.PrimaryPage <> 1 then
      cbbFak.Items.Insert(0, '')
    else
    begin
      if (FFakStamp <> nil) and (FFakStamp.Fak <> nil) then
      begin
        i := cbbFak.Items.IndexOf(FFakStamp.Fak.ToString);
        if i >= 0 then
          cbbFak.Items.Delete(i);
      end;
    end;
    if FKoAndFak then
      Self.GetLastFak
    else
    begin
      if cbbFak.Items.Count > 0 then
        cbbFak.ItemIndex := 0
      else
        cbbFak.ItemIndex := -1;
      Self.cbbFakChange(Sender);
    end;
  end;
end;

procedure TClockInForm.cbbKstFill(Sender: TObject);
var
  i: Integer;
begin
  if Sender is TKstList then
  begin
    Self.KstList := Sender as TKstList;
    cbbKst.Clear;
    for i := 0 to Self.KstList.Count - 1 do
      cbbKst.Items.Add(Self.KstList.Items[i].ToString);
    if cbbKst.Items.Count > 0 then
      cbbKst.ItemIndex := 0
    else
      cbbKst.ItemIndex := -1;
  end;
end;

procedure TClockInForm.cbbMatFill(Sender: TObject);
var
  i: Integer;
begin
  cbbMat.Clear;
  for i := 0 to Self.MatList.Count - 1 do
    cbbMat.Items.Add(Self.MatList.Items[i].ToString);
  if cbbMat.Items.Count > 0 then
    cbbMat.ItemIndex := 0
  else
    cbbMat.ItemIndex := -1;
end;

procedure TClockInForm.cbbTaetChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure TClockInForm.cbbTaetFill(Sender: TObject);
var
  i: Integer;
begin
  if Sender is TTaetList then
  begin
    Self.TaetList := Sender as TTaetList;
    cbbTaet.Items.Clear;
    for i := 0 to Self.TaetList.Count - 1 do
      cbbTaet.Items.Add(Self.TaetList.Items[i].Bezeichnung);
    if cbbTaet.Items.Count > 0 then
      cbbTaet.ItemIndex := 0
    else
      cbbTaet.ItemIndex := -1;
  end;
end;

function TClockInForm.CheckMask: Boolean;
var
  Error: string;
  d: Double;
begin
  Error := '';
  if (Error = '') and (cbbClockIn.ItemIndex = -1) then
  begin
    Error := 'Es muss eine Buchungsart gewählt werden!';
    cbbClockIn.SetFocus;
  end;
  if (Error = '') and (copy(cbbClockIn.Text, 1, 2) = 'AA') and
    ((cbbFak.ItemIndex = -1) or (cbbFak.Text = '')) then
  begin
    Error := 'Es muss ein Auftrag gewählt werden!';
    cbbFak.SetFocus;
  end;
  if (Error = '') and pnlTaet.Visible and (copy(cbbClockIn.Text, 1, 2) = 'AA')
    and (cbbTaet.ItemIndex = -1) then
  begin
    Error := 'Es muss eine Tätigkeit gewählt werden!';
    cbbTaet.SetFocus;
  end;
  if (Error = '') and (copy(cbbClockIn.Text, 1, 2) = 'VM') and
    (cbbMat.ItemIndex = -1) then
  begin
    Error := 'Es muss Verbrauchsmaterial gewählt werden!';
    cbbMat.SetFocus;
  end;
  if (Error = '') and (copy(cbbClockIn.Text, 1, 2) = 'VM') and
    (edtMenge.Text = '') then
  begin
    Error := 'Menge darf nicht leer sein!';
    edtMenge.SetFocus;
  end;
  if (Error = '') and (copy(cbbClockIn.Text, 1, 2) = 'VM') and
    (edtMenge.Text <> '') then
  begin
    if not Double.TryParse(edtMenge.Text, d) then
    begin
      Error := 'Menge ist keine gültige Gleitkommazahl!';
      edtMenge.SetFocus;
    end;
  end;
  if Error <> '' then
    MessageDLG(Error, mtWarning, [mbOK]);
  Result := Error = '';
end;

procedure TClockInForm.clockInButtonClick(Sender: TObject);
var
  btn: TBitBtn;
var
  stamp: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      if (Sender as TStampModel).Result.ResultValue then
      begin
        Self.PropertyChanged;
        Self.Close;
      end
      else
        Self.Error(Sender, (Sender as TStampModel).Result.ResultMessage);
    end;
  end;

  procedure HandlingError(Sender: TObject; AMsg: string);
  begin
    Self.Error(Sender, AMsg);
  end;

begin
  Self.MainConfig.TimerReset;
  if Sender is TBitBtn then
  begin
    btn := Sender as TBitBtn;
    stamp := TStampModel.Create;
    stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
    stamp.Art := copy(btn.Name, 4, 2);
    stamp.Zeitpunkt := Self.TimePoint;
    stamp.OnPropertyChanged := Callback;
    stamp.OnError := HandlingError;
    stamp.Insert(Self.MainConfig.Uri);
  end;
end;

procedure TClockInForm.CreateButtons;
var
  i: Integer;
begin
  i := 0;
  pnlKOGE.Visible := ContainsElement('KO', Self.MainConfig.ClockInConfig.List);
  if pnlKOGE.Visible then
  begin
    pnlKOGE.Top := 64 + (i * 56);
    Inc(i);
  end;
  pnlPAPE.Visible := ContainsElement('PA', Self.MainConfig.ClockInConfig.List);
  if pnlPAPE.Visible then
  begin
    pnlPAPE.Top := 64 + (i * 56);
    Inc(i);
  end;
  pnlDADE.Visible := ContainsElement('DA', Self.MainConfig.ClockInConfig.List);
  if pnlDADE.Visible then
  begin
    pnlDADE.Top := 64 + (i * 56);
    Inc(i);
  end;
  pnlKAKE.Visible := ContainsElement('KA', Self.MainConfig.ClockInConfig.List);
  if pnlKAKE.Visible then
  begin
    pnlKAKE.Top := 64 + (i * 56);
    Inc(i);
  end;
  pnlData1.Height := 64 + (i * 56);
  Self.WebFormResize(Self);
end;

procedure TClockInForm.DisableBuArts(status: string);
var
  s, t: string;
  i: Integer;
  found: Boolean;
begin
  s := GetDisabledBuArts(status);
  while s <> '' do
  begin
    t := Cut(s, ',');
    found := false;
    i := cbbClockIn.Items.Count - 1;
    while not found and (i >= 0) do
      if UpperCase(copy(cbbClockIn.Items[i], 1, 2)) = t then
        found := true
      else
        Dec(i);
    if found then
      cbbClockIn.Items.Delete(i);
  end;
  Self.AnalyzeDefBuArts;
  Self.DisableDefBuArts;
end;

procedure TClockInForm.DisableButtons(status: string);
var
  s: string;
begin
  s := ',' + GetDisabledBuArts(status) + ',';
  btnKO.Enabled := Pos(',KO,', s) = 0;
  btnGE.Enabled := Pos(',GE,', s) = 0;
  btnPA.Enabled := Pos(',PA,', s) = 0;
  btnPE.Enabled := Pos(',PE,', s) = 0;
  btnDA.Enabled := Pos(',DA,', s) = 0;
  btnDE.Enabled := Pos(',DE,', s) = 0;
  btnKA.Enabled := Pos(',KA,', s) = 0;
  btnKE.Enabled := Pos(',KE,', s) = 0;
end;

procedure TClockInForm.DisableDefBuArt(index: Integer);
var
  stamp: TStampModel;
  procedure Callback(Sender: TObject);
  var
    Art: string;
    i: Integer;
    found: Boolean;
  begin
    if Sender is TStampModel then
    begin
      Art := (Sender as TStampModel).Art;
      if Art = '' then
        Art := 'E' + Self.DefBuArts[index];
      i := cbbClockIn.Items.Count - 1;
      found := false;
      while not found and (i >= 0) do
        if copy(cbbClockIn.Items[i], 1, 2) = Art then
          found := true
        else
          Dec(i);
      if found then
        cbbClockIn.Items.Delete(i);
    end;
    Self.DisableDefBuArt(index + 1);
  end;

begin
  if index < Self.DefBuArts.Count then
  begin
    stamp := TStampModel.Create;
    stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
    stamp.OnPropertyChanged := Callback;
    stamp.OnError := Self.Error;
    stamp.GetLastDefStamp(Self.MainConfig.Uri, Self.DefBuArts[index]);
  end
  else
  begin
    if Self.MainConfig.CommonConfig.WorkOrderTimes then
      Self.DisableFakBuArt;
    if cbbClockIn.Items.Count > 0 then
    begin
      cbbClockIn.ItemIndex := 0;
      Self.cbbClockInChange(Self);
    end
    else
      cbbClockIn.ItemIndex := -1;
  end;
end;

procedure TClockInForm.DisableDefBuArts;
begin
  if Self.DefBuArts.Count > 0 then
    Self.DisableDefBuArt(0)
  else
  begin
    if Self.MainConfig.CommonConfig.WorkOrderTimes then
      Self.DisableFakBuArt
    else if cbbClockIn.Items.Count > 0 then
    begin
      cbbClockIn.ItemIndex := 0;
      Self.cbbClockInChange(Self);
    end
    else
      cbbClockIn.ItemIndex := -1;
  end;
end;

procedure TClockInForm.DisableFakBuArt;
var
  stamp: TStampModel;
  procedure Callback(Sender: TObject);
  var
    i: Integer;
    found: Boolean;
  begin
    if Sender is TStampModel then
    begin
      if ((Sender as TStampModel).Fak.Id = 0) or
        (Self.MainConfig.CommonConfig.PrimaryPage = 1) then
      begin
        i := cbbClockIn.Items.Count - 1;
        found := false;
        while not found and (i >= 0) do
          if UpperCase(copy(cbbClockIn.Items[i], 1, 2)) = 'AE' then
            found := true
          else
            Dec(i);
        if found then
          cbbClockIn.Items.Delete(i);
      end;
      if cbbClockIn.Items.Count > 0 then
      begin
        cbbClockIn.ItemIndex := 0;
        Self.cbbClockInChange(Self);
      end
      else
        cbbClockIn.ItemIndex := -1;
    end;
  end;

begin
  stamp := TStampModel.Create;
  stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
  stamp.OnPropertyChanged := Callback;
  stamp.OnError := Self.Error;
  stamp.GetLastFakStamp(Self.MainConfig.Uri);
end;

procedure TClockInForm.edtFakFindChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.FakList.GetAll(Self.MainConfig.Uri, edtFakFind.Text);
end;

procedure TClockInForm.edtKstFindChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.KstList.GetAll(Self.MainConfig.Uri, edtKstFind.Text);
end;

procedure TClockInForm.edtMengeChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure TClockInForm.edtMengeKeyPress(Sender: TObject; var Key: Char);
begin
  if not(Key in ['0' .. '9', ',', #8]) then
    Key := #0;
end;

procedure TClockInForm.edtTaetFindChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure TClockInForm.Error(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtError, [mbOK], nil);
end;

procedure TClockInForm.GetLastFak;
var
  stamp: TStampModel;
  procedure Callback(Sender: TObject);
  var
    i: Integer;
  begin
    if Sender is TStampModel then
    begin
      stamp := Sender as TStampModel;
      i := Self.FakList.IndexOf(stamp.Fak.ToString);
      if i >= 0 then
        cbbFak.ItemIndex := i + 1
      else
        cbbFak.ItemIndex := 0;
      Self.cbbFakChange(Sender);
      FKoAndFak := false;
    end;
  end;

begin
  stamp := TStampModel.Create;
  stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
  stamp.OnPropertyChanged := Callback;
  stamp.OnError := Self.Error;
  stamp.GetLastFak(Self.MainConfig.Uri);
end;

procedure TClockInForm.GetLastFakStamp;
var
  stamp: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
      FFakStamp := Sender as TStampModel
    else
      FFakStamp := nil;
    Self.WebFormResize(Self);
  end;

begin
  stamp := TStampModel.Create;
  stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
  stamp.OnPropertyChanged := Callback;
  stamp.GetLastFakStamp(Self.MainConfig.Uri);
end;

function TClockInForm.GetMask: TStampModel;
var
  i: Integer;
  d: Double;
begin
  Result := TStampModel.Create;
  Result.PersonalNr := Self.MainConfig.User.PersonalNr;
  Result.Art := copy(cbbClockIn.Text, 1, 2);
  Result.Zeitpunkt := Self.TimePoint;
  Result.Kst.ClearValues;
  if pnlKst.Visible then
  begin
    i := Self.KstList.IndexOf(cbbKst.Text);
    if i > 0 then
      Result.Kst := Self.KstList.Items[i];
  end;
  Result.Fak.ClearValues;
  if pnlFak.Visible then
  begin
    i := Self.FakList.IndexOf(cbbFak.Text);
    if i >= 0 then
      Result.Fak := Self.FakList.Items[i];
  end;
  Result.Taet.ClearValues;
  if pnlTaet.Visible then
  begin
    i := Self.TaetList.IndexOf(cbbTaet.Text);
    if i >= 0 then
      Result.Taet := Self.TaetList.Items[i];
  end;
  Result.Mat.ClearValues;
  Result.Menge := 0;
  if pnlMat.Visible then
  begin
    i := Self.MatList.IndexOf(cbbMat.Text);
    if i >= 0 then
      Result.Mat := Self.MatList.Items[i];
    if Double.TryParse(edtMenge.Text, d) then
      Result.Menge := d;
  end;
end;

procedure TClockInForm.GetStatus;
var
  stamp: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      FStamp := Sender as TStampModel;
      DisableBuArts(FStamp.Art);
      Self.DisableButtons(FStamp.Art);
    end
    else
      FStamp := nil;
    Self.WebFormResize(Self);
  end;

begin
  stamp := TStampModel.Create;
  stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
  stamp.OnPropertyChanged := Callback;
  stamp.OnError := Self.Error;
  stamp.GetLastStamp(Self.MainConfig.Uri);
end;

procedure TClockInForm.lblDateClick(Sender: TObject);
var
  frm: TClockEditForm;
begin
  tmrClock.Enabled := false;
  frm := TClockEditForm.Create(Self);
  await(TClockEditForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  frm.TimePoint := Self.TimePoint;
  try
    await(TModalResult, frm.Execute);
    if frm.ModalResult = mrOK then
    begin
      Self.TimePoint := frm.TimePoint;
      Self.DisableBuArts('');
      Self.DisableButtons('');
    end
    else
      Self.tmrClock.Enabled := true;
  finally
    frm.Free;
  end;
end;

procedure TClockInForm.ParaCallback(Sender: TObject);
begin
  if Sender is TFakParaModel then
  begin
    Self.Para := Sender as TFakParaModel;
    pnlTaet.Visible := Self.Para.TaetVerw;
    cbbClockInFill;
  end;
end;

procedure TClockInForm.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TClockInForm.SetDefBuArts(const Value: TStringList);
begin
  FDefBuArts := Value;
end;

procedure TClockInForm.SetFakList(const Value: TFakList);
begin
  FFakList := Value;
end;

procedure TClockInForm.SetKstList(const Value: TKstList);
begin
  FKstList := Value;
end;

procedure TClockInForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  pnlKst.Visible := Self.MainConfig.CommonConfig.UseKst;
  Self.CalcPanelHeight;
  if Self.MainConfig.CommonConfig.UseKst then
    Self.KstList.GetAll(Self.MainConfig.Uri, edtKstFind.Text);
  Self.Para.Get(Self.MainConfig.Uri);
end;

procedure TClockInForm.SetMatList(const Value: TMatList);
begin
  FMatList := Value;
end;

procedure TClockInForm.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TClockInForm.SetPara(const Value: TFakParaModel);
begin
  FPara := Value;
end;

procedure TClockInForm.SetTaetList(const Value: TTaetList);
begin
  FTaetList := Value;
end;

procedure TClockInForm.SetTimePoint(const Value: TDateTime);
begin
  FTimePoint := Value;
  lblDate.Caption := FormatDateTime('dddd dd.mm.yyyy', Self.TimePoint);
  lblDate1.Caption := lblDate.Caption;
  lblTime.Caption := FormatDateTime('hh:nn:ss', Self.TimePoint);
  lblTime1.Caption := lblTime.Caption;
end;

procedure TClockInForm.tmrClockTimer(Sender: TObject);
begin
  Self.TimePoint := now;
end;

procedure TClockInForm.WebFormCreate(Sender: TObject);
begin
  Self.FakList := TFakList.Create;
  Self.FakList.OnPropertyChanged := cbbFakFill;
  Self.FakList.OnError := Self.Error;
  Self.TaetList := TTaetList.Create;
  Self.TaetList.OnPropertyChanged := cbbTaetFill;
  Self.TaetList.OnError := Self.Error;
  Self.KstList := TKstList.Create;
  Self.KstList.OnPropertyChanged := cbbKstFill;
  Self.KstList.OnError := Self.Error;
  Self.DefBuArts := TStringList.Create;
  Self.Para := TFakParaModel.Create;
  Self.Para.OnPropertyChanged := ParaCallback;
  Self.Para.OnError := Self.Error;
  Self.MatList := TMatList.Create;
  Self.MatList.OnPropertyChanged := cbbMatFill;
  Self.MatList.OnError := Self.Error;
  edtFakFind.Text := '';
  edtTaetFind.Text := '';
  edtKstFind.Text := '';
  edtMenge.Text := '';
  FStamp := nil;
  FFakStamp := nil;
  FKoAndFak := false;
end;

procedure TClockInForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TClockInForm.WebFormResize(Sender: TObject);
var
  i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Stempelbereich';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, FStamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Stempelbereich';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, FStamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  if (Self.MainConfig <> nil) and
    (Self.MainConfig.ClockInConfig.UserInterface = 1) then
  begin
    pnlData.Visible := true;
    pnlData1.Visible := false;
    i := (Self.ClientWidth - pnlData.Width) div 2;
    if i < 0 then
      i := 0;
    pnlData.Left := i;
    i := Self.ClientHeight - pnlHeader.Height - pnlStatus.Height -
      pnlData.Height;
    if pnlFooter.Visible then
      i := i - pnlFooter.Height;
    if i < 0 then
      i := 0;
    pnlData.Top := pnlStatus.Top + pnlStatus.Height + (i div 2);
  end
  else
  begin
    pnlData.Visible := false;
    pnlData1.Visible := true;
    i := (Self.ClientWidth - pnlData1.Width) div 2;
    if i < 0 then
      i := 0;
    pnlData1.Left := i;
    i := Self.ClientHeight - pnlHeader.Height - pnlStatus.Height -
      pnlData1.Height;
    if pnlFooter.Visible then
      i := i - pnlFooter.Height;
    if i < 0 then
      i := 0;
    pnlData1.Top := pnlStatus.Top + pnlStatus.Height + (i div 2);
  end;
end;

procedure TClockInForm.WebFormShow(Sender: TObject);
begin
  Self.tmrClockTimer(Sender);
  Self.cbbClockInChange(Sender);
end;

procedure TClockInForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlData := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  lblDate := TLabel.Create(Self);
  lblTime := TLabel.Create(Self);
  cbbClockIn := TComboBox.Create(Self);
  btnClockIn := TBitBtn.Create(Self);
  pnlFak := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  cbbFak := TComboBox.Create(Self);
  edtFakFind := TEdit.Create(Self);
  pnlTaet := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  cbbTaet := TComboBox.Create(Self);
  edtTaetFind := TEdit.Create(Self);
  pnlKst := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  cbbKst := TComboBox.Create(Self);
  edtKstFind := TEdit.Create(Self);
  pnlMat := TPanel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  cbbMat := TComboBox.Create(Self);
  edtMenge := TEdit.Create(Self);
  pnlData1 := TPanel.Create(Self);
  lblDate1 := TLabel.Create(Self);
  lblTime1 := TLabel.Create(Self);
  pnlKOGE := TPanel.Create('pnlKOGE');
  btnKO := TBitBtn.Create(Self);
  btnGE := TBitBtn.Create(Self);
  pnlPAPE := TPanel.Create('pnlPAPE');
  btnPA := TBitBtn.Create(Self);
  btnPE := TBitBtn.Create(Self);
  pnlDADE := TPanel.Create('pnlDADE');
  btnDA := TBitBtn.Create(Self);
  btnDE := TBitBtn.Create(Self);
  pnlKAKE := TPanel.Create('pnlKAKE');
  btnKA := TBitBtn.Create(Self);
  btnKE := TBitBtn.Create(Self);
  tmrClock := TTimer.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  lblDate.BeforeLoadDFMValues;
  lblTime.BeforeLoadDFMValues;
  cbbClockIn.BeforeLoadDFMValues;
  btnClockIn.BeforeLoadDFMValues;
  pnlFak.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  cbbFak.BeforeLoadDFMValues;
  edtFakFind.BeforeLoadDFMValues;
  pnlTaet.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  cbbTaet.BeforeLoadDFMValues;
  edtTaetFind.BeforeLoadDFMValues;
  pnlKst.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  cbbKst.BeforeLoadDFMValues;
  edtKstFind.BeforeLoadDFMValues;
  pnlMat.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  cbbMat.BeforeLoadDFMValues;
  edtMenge.BeforeLoadDFMValues;
  pnlData1.BeforeLoadDFMValues;
  lblDate1.BeforeLoadDFMValues;
  lblTime1.BeforeLoadDFMValues;
  pnlKOGE.BeforeLoadDFMValues;
  btnKO.BeforeLoadDFMValues;
  btnGE.BeforeLoadDFMValues;
  pnlPAPE.BeforeLoadDFMValues;
  btnPA.BeforeLoadDFMValues;
  btnPE.BeforeLoadDFMValues;
  pnlDADE.BeforeLoadDFMValues;
  btnDA.BeforeLoadDFMValues;
  btnDE.BeforeLoadDFMValues;
  pnlKAKE.BeforeLoadDFMValues;
  btnKA.BeforeLoadDFMValues;
  btnKE.BeforeLoadDFMValues;
  tmrClock.BeforeLoadDFMValues;
  try
    Name := 'ClockInForm';
    Width := 881;
    Height := 795;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnScroll', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 881;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UClockInForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Stempelbereich';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UClockInForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 771;
    pnlFooter.Width := 881;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 881;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 881;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 8;
    pnlData.Top := 98;
    pnlData.Width := 216;
    pnlData.Height := 655;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 3;
    pnlData.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlData);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 80;
    WebLabel1.Width := 65;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Bitte w'#228'hlen';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    lblDate.SetParentComponent(pnlData);
    lblDate.Name := 'lblDate';
    lblDate.Left := 8;
    lblDate.Top := 8;
    lblDate.Width := 200;
    lblDate.Height := 21;
    lblDate.Alignment := taCenter;
    lblDate.AutoSize := False;
    lblDate.Font.Charset := ANSI_CHARSET;
    lblDate.Font.Color := clNavy;
    lblDate.Font.Height := -16;
    lblDate.Font.Name := 'Segoe UI Semibold';
    lblDate.Font.Style := [fsBold];
    lblDate.HeightPercent := 100.000000000000000000;
    lblDate.ParentFont := False;
    lblDate.WidthPercent := 100.000000000000000000;
    SetEvent(lblDate, Self, 'OnClick', 'lblDateClick');
    lblTime.SetParentComponent(pnlData);
    lblTime.Name := 'lblTime';
    lblTime.Left := 8;
    lblTime.Top := 35;
    lblTime.Width := 200;
    lblTime.Height := 21;
    lblTime.Alignment := taCenter;
    lblTime.AutoSize := False;
    lblTime.Font.Charset := ANSI_CHARSET;
    lblTime.Font.Color := clNavy;
    lblTime.Font.Height := -16;
    lblTime.Font.Name := 'Segoe UI Semibold';
    lblTime.Font.Style := [fsBold];
    lblTime.HeightPercent := 100.000000000000000000;
    lblTime.ParentFont := False;
    lblTime.WidthPercent := 100.000000000000000000;
    SetEvent(lblTime, Self, 'OnClick', 'lblDateClick');
    cbbClockIn.SetParentComponent(pnlData);
    cbbClockIn.Name := 'cbbClockIn';
    cbbClockIn.Left := 8;
    cbbClockIn.Top := 96;
    cbbClockIn.Width := 200;
    cbbClockIn.Height := 23;
    cbbClockIn.HeightPercent := 100.000000000000000000;
    cbbClockIn.Text := 'cbbClockIn';
    cbbClockIn.WidthPercent := 100.000000000000000000;
    SetEvent(cbbClockIn, Self, 'OnChange', 'cbbClockInChange');
    cbbClockIn.ItemIndex := -1;
    btnClockIn.SetParentComponent(pnlData);
    btnClockIn.Name := 'btnClockIn';
    btnClockIn.Left := 8;
    btnClockIn.Top := 528;
    btnClockIn.Width := 200;
    btnClockIn.Height := 48;
    btnClockIn.Caption := 'Stempeln';
    btnClockIn.Color := clNone;
    btnClockIn.Glyph.LoadFromFile('UClockInForm.pnlData.btnClockIn.Glyph.png');
    btnClockIn.GlyphSize := 32;
    btnClockIn.HeightPercent := 100.000000000000000000;
    btnClockIn.WidthPercent := 100.000000000000000000;
    SetEvent(btnClockIn, Self, 'OnClick', 'btnClockInClick');
    pnlFak.SetParentComponent(pnlData);
    pnlFak.Name := 'pnlFak';
    pnlFak.Left := 0;
    pnlFak.Top := 220;
    pnlFak.Width := 216;
    pnlFak.Height := 100;
    pnlFak.Caption := 'pnlFak';
    pnlFak.ChildOrder := 5;
    pnlFak.ShowCaption := False;
    WebLabel2.SetParentComponent(pnlFak);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 8;
    WebLabel2.Width := 40;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Auftrag';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(pnlFak);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 8;
    WebLabel3.Top := 56;
    WebLabel3.Width := 81;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Auftrag suchen';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    cbbFak.SetParentComponent(pnlFak);
    cbbFak.Name := 'cbbFak';
    cbbFak.Left := 8;
    cbbFak.Top := 24;
    cbbFak.Width := 200;
    cbbFak.Height := 23;
    cbbFak.HeightPercent := 100.000000000000000000;
    cbbFak.Text := 'cbbFak';
    cbbFak.WidthPercent := 100.000000000000000000;
    SetEvent(cbbFak, Self, 'OnChange', 'cbbFakChange');
    cbbFak.ItemIndex := -1;
    edtFakFind.SetParentComponent(pnlFak);
    edtFakFind.Name := 'edtFakFind';
    edtFakFind.Left := 8;
    edtFakFind.Top := 72;
    edtFakFind.Width := 200;
    edtFakFind.Height := 22;
    edtFakFind.ChildOrder := 3;
    edtFakFind.HeightPercent := 100.000000000000000000;
    edtFakFind.Text := 'edtFakFind';
    edtFakFind.WidthPercent := 100.000000000000000000;
    SetEvent(edtFakFind, Self, 'OnChange', 'edtFakFindChange');
    pnlTaet.SetParentComponent(pnlData);
    pnlTaet.Name := 'pnlTaet';
    pnlTaet.Left := 0;
    pnlTaet.Top := 320;
    pnlTaet.Width := 216;
    pnlTaet.Height := 100;
    pnlTaet.Caption := 'pnlFak';
    pnlTaet.ChildOrder := 5;
    pnlTaet.ShowCaption := False;
    WebLabel5.SetParentComponent(pnlTaet);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 8;
    WebLabel5.Top := 8;
    WebLabel5.Width := 45;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'T'#228'tigkeit';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(pnlTaet);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 8;
    WebLabel6.Top := 56;
    WebLabel6.Width := 86;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'T'#228'tigkeit suchen';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    cbbTaet.SetParentComponent(pnlTaet);
    cbbTaet.Name := 'cbbTaet';
    cbbTaet.Left := 8;
    cbbTaet.Top := 24;
    cbbTaet.Width := 200;
    cbbTaet.Height := 23;
    cbbTaet.HeightPercent := 100.000000000000000000;
    cbbTaet.Text := 'cbbTaet';
    cbbTaet.WidthPercent := 100.000000000000000000;
    SetEvent(cbbTaet, Self, 'OnChange', 'cbbTaetChange');
    cbbTaet.ItemIndex := -1;
    edtTaetFind.SetParentComponent(pnlTaet);
    edtTaetFind.Name := 'edtTaetFind';
    edtTaetFind.Left := 8;
    edtTaetFind.Top := 72;
    edtTaetFind.Width := 200;
    edtTaetFind.Height := 22;
    edtTaetFind.ChildOrder := 3;
    edtTaetFind.HeightPercent := 100.000000000000000000;
    edtTaetFind.Text := 'edtTaetFind';
    edtTaetFind.WidthPercent := 100.000000000000000000;
    SetEvent(edtTaetFind, Self, 'OnChange', 'cbbFakChange');
    pnlKst.SetParentComponent(pnlData);
    pnlKst.Name := 'pnlKst';
    pnlKst.Left := 0;
    pnlKst.Top := 120;
    pnlKst.Width := 216;
    pnlKst.Height := 100;
    pnlKst.Caption := 'pnlFak';
    pnlKst.ChildOrder := 5;
    pnlKst.ShowCaption := False;
    WebLabel4.SetParentComponent(pnlKst);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 8;
    WebLabel4.Top := 8;
    WebLabel4.Width := 63;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Kostenstelle';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(pnlKst);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 56;
    WebLabel7.Width := 104;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'Kostenstelle suchen';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    cbbKst.SetParentComponent(pnlKst);
    cbbKst.Name := 'cbbKst';
    cbbKst.Left := 8;
    cbbKst.Top := 24;
    cbbKst.Width := 200;
    cbbKst.Height := 23;
    cbbKst.HeightPercent := 100.000000000000000000;
    cbbKst.Text := 'cbbKst';
    cbbKst.WidthPercent := 100.000000000000000000;
    SetEvent(cbbKst, Self, 'OnChange', 'cbbFakChange');
    cbbKst.ItemIndex := -1;
    edtKstFind.SetParentComponent(pnlKst);
    edtKstFind.Name := 'edtKstFind';
    edtKstFind.Left := 8;
    edtKstFind.Top := 72;
    edtKstFind.Width := 200;
    edtKstFind.Height := 22;
    edtKstFind.ChildOrder := 3;
    edtKstFind.HeightPercent := 100.000000000000000000;
    edtKstFind.Text := 'edtKstFind';
    edtKstFind.WidthPercent := 100.000000000000000000;
    SetEvent(edtKstFind, Self, 'OnChange', 'edtKstFindChange');
    pnlMat.SetParentComponent(pnlData);
    pnlMat.Name := 'pnlMat';
    pnlMat.Left := 0;
    pnlMat.Top := 420;
    pnlMat.Width := 216;
    pnlMat.Height := 100;
    pnlMat.Caption := 'pnlFak';
    pnlMat.ChildOrder := 5;
    pnlMat.ShowCaption := False;
    WebLabel8.SetParentComponent(pnlMat);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 8;
    WebLabel8.Top := 8;
    WebLabel8.Width := 101;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'Verbrauchsmaterial';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(pnlMat);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 8;
    WebLabel9.Top := 56;
    WebLabel9.Width := 37;
    WebLabel9.Height := 15;
    WebLabel9.Caption := 'Menge';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    cbbMat.SetParentComponent(pnlMat);
    cbbMat.Name := 'cbbMat';
    cbbMat.Left := 8;
    cbbMat.Top := 24;
    cbbMat.Width := 200;
    cbbMat.Height := 23;
    cbbMat.HeightPercent := 100.000000000000000000;
    cbbMat.Text := 'cbbMat';
    cbbMat.WidthPercent := 100.000000000000000000;
    SetEvent(cbbMat, Self, 'OnChange', 'cbbTaetChange');
    cbbMat.ItemIndex := -1;
    edtMenge.SetParentComponent(pnlMat);
    edtMenge.Name := 'edtMenge';
    edtMenge.Left := 8;
    edtMenge.Top := 72;
    edtMenge.Width := 200;
    edtMenge.Height := 22;
    edtMenge.ChildOrder := 3;
    edtMenge.HeightPercent := 100.000000000000000000;
    edtMenge.Text := 'edtMenge';
    edtMenge.WidthPercent := 100.000000000000000000;
    SetEvent(edtMenge, Self, 'OnChange', 'edtMengeChange');
    SetEvent(edtMenge, Self, 'OnKeyPress', 'edtMengeKeyPress');
    pnlData1.SetParentComponent(Self);
    pnlData1.Name := 'pnlData1';
    pnlData1.Left := 272;
    pnlData1.Top := 98;
    pnlData1.Width := 316;
    pnlData1.Height := 288;
    pnlData1.Caption := 'pnlData';
    pnlData1.ChildOrder := 3;
    pnlData1.ShowCaption := False;
    lblDate1.SetParentComponent(pnlData1);
    lblDate1.Name := 'lblDate1';
    lblDate1.Left := 8;
    lblDate1.Top := 8;
    lblDate1.Width := 300;
    lblDate1.Height := 21;
    lblDate1.Alignment := taCenter;
    lblDate1.AutoSize := False;
    lblDate1.Font.Charset := ANSI_CHARSET;
    lblDate1.Font.Color := clNavy;
    lblDate1.Font.Height := -16;
    lblDate1.Font.Name := 'Segoe UI Semibold';
    lblDate1.Font.Style := [fsBold];
    lblDate1.HeightPercent := 100.000000000000000000;
    lblDate1.ParentFont := False;
    lblDate1.WidthPercent := 100.000000000000000000;
    SetEvent(lblDate1, Self, 'OnClick', 'lblDateClick');
    lblTime1.SetParentComponent(pnlData1);
    lblTime1.Name := 'lblTime1';
    lblTime1.Left := 8;
    lblTime1.Top := 35;
    lblTime1.Width := 300;
    lblTime1.Height := 21;
    lblTime1.Alignment := taCenter;
    lblTime1.AutoSize := False;
    lblTime1.Font.Charset := ANSI_CHARSET;
    lblTime1.Font.Color := clNavy;
    lblTime1.Font.Height := -16;
    lblTime1.Font.Name := 'Segoe UI Semibold';
    lblTime1.Font.Style := [fsBold];
    lblTime1.HeightPercent := 100.000000000000000000;
    lblTime1.ParentFont := False;
    lblTime1.WidthPercent := 100.000000000000000000;
    SetEvent(lblTime1, Self, 'OnClick', 'lblDateClick');
    pnlKOGE.SetParentComponent(pnlData1);
    pnlKOGE.Name := 'pnlKOGE';
    pnlKOGE.Left := 0;
    pnlKOGE.Top := 64;
    pnlKOGE.Width := 316;
    pnlKOGE.Height := 56;
    pnlKOGE.Caption := 'pnlKOGE';
    pnlKOGE.ChildOrder := 2;
    pnlKOGE.ShowCaption := False;
    btnKO.SetParentComponent(pnlKOGE);
    btnKO.Name := 'btnKO';
    btnKO.Left := 4;
    btnKO.Top := 3;
    btnKO.Width := 150;
    btnKO.Height := 48;
    btnKO.Caption := 'Kommen';
    btnKO.Color := clNone;
    btnKO.Glyph.LoadFromFile('UClockInForm.pnlKOGE.btnKO.Glyph.png');
    btnKO.GlyphSize := 32;
    btnKO.HeightPercent := 100.000000000000000000;
    btnKO.WidthPercent := 100.000000000000000000;
    SetEvent(btnKO, Self, 'OnClick', 'clockInButtonClick');
    btnGE.SetParentComponent(pnlKOGE);
    btnGE.Name := 'btnGE';
    btnGE.Left := 160;
    btnGE.Top := 3;
    btnGE.Width := 150;
    btnGE.Height := 48;
    btnGE.Caption := 'Gehen';
    btnGE.Color := clNone;
    btnGE.Glyph.LoadFromFile('UClockInForm.pnlKOGE.btnGE.Glyph.png');
    btnGE.GlyphSize := 32;
    btnGE.HeightPercent := 100.000000000000000000;
    btnGE.WidthPercent := 100.000000000000000000;
    SetEvent(btnGE, Self, 'OnClick', 'clockInButtonClick');
    pnlPAPE.SetParentComponent(pnlData1);
    pnlPAPE.Name := 'pnlPAPE';
    pnlPAPE.Left := 0;
    pnlPAPE.Top := 120;
    pnlPAPE.Width := 316;
    pnlPAPE.Height := 56;
    pnlPAPE.Caption := 'pnlPAPE';
    pnlPAPE.ChildOrder := 2;
    pnlPAPE.ShowCaption := False;
    btnPA.SetParentComponent(pnlPAPE);
    btnPA.Name := 'btnPA';
    btnPA.Left := 4;
    btnPA.Top := 3;
    btnPA.Width := 150;
    btnPA.Height := 48;
    btnPA.Caption := 'Pause-Anfang';
    btnPA.Color := clNone;
    btnPA.Glyph.LoadFromFile('UClockInForm.pnlPAPE.btnPA.Glyph.png');
    btnPA.GlyphSize := 32;
    btnPA.HeightPercent := 100.000000000000000000;
    btnPA.WidthPercent := 100.000000000000000000;
    SetEvent(btnPA, Self, 'OnClick', 'clockInButtonClick');
    btnPE.SetParentComponent(pnlPAPE);
    btnPE.Name := 'btnPE';
    btnPE.Left := 160;
    btnPE.Top := 3;
    btnPE.Width := 150;
    btnPE.Height := 48;
    btnPE.Caption := 'Pause-Ende';
    btnPE.Color := clNone;
    btnPE.Glyph.LoadFromFile('UClockInForm.pnlPAPE.btnPE.Glyph.png');
    btnPE.GlyphSize := 32;
    btnPE.HeightPercent := 100.000000000000000000;
    btnPE.WidthPercent := 100.000000000000000000;
    SetEvent(btnPE, Self, 'OnClick', 'clockInButtonClick');
    pnlDADE.SetParentComponent(pnlData1);
    pnlDADE.Name := 'pnlDADE';
    pnlDADE.Left := 0;
    pnlDADE.Top := 176;
    pnlDADE.Width := 316;
    pnlDADE.Height := 56;
    pnlDADE.Caption := 'pnlPaPe';
    pnlDADE.ChildOrder := 2;
    pnlDADE.ShowCaption := False;
    btnDA.SetParentComponent(pnlDADE);
    btnDA.Name := 'btnDA';
    btnDA.Left := 4;
    btnDA.Top := 3;
    btnDA.Width := 150;
    btnDA.Height := 48;
    btnDA.Caption := 'Dienstgang-Anfang';
    btnDA.Color := clNone;
    btnDA.Glyph.LoadFromFile('UClockInForm.pnlDADE.btnDA.Glyph.png');
    btnDA.GlyphSize := 32;
    btnDA.HeightPercent := 100.000000000000000000;
    btnDA.WidthPercent := 100.000000000000000000;
    SetEvent(btnDA, Self, 'OnClick', 'clockInButtonClick');
    btnDE.SetParentComponent(pnlDADE);
    btnDE.Name := 'btnDE';
    btnDE.Left := 160;
    btnDE.Top := 3;
    btnDE.Width := 150;
    btnDE.Height := 48;
    btnDE.Caption := 'Dienstgang-Ende';
    btnDE.Color := clNone;
    btnDE.Glyph.LoadFromFile('UClockInForm.pnlDADE.btnDE.Glyph.png');
    btnDE.GlyphSize := 32;
    btnDE.HeightPercent := 100.000000000000000000;
    btnDE.WidthPercent := 100.000000000000000000;
    SetEvent(btnDE, Self, 'OnClick', 'clockInButtonClick');
    pnlKAKE.SetParentComponent(pnlData1);
    pnlKAKE.Name := 'pnlKAKE';
    pnlKAKE.Left := 0;
    pnlKAKE.Top := 232;
    pnlKAKE.Width := 316;
    pnlKAKE.Height := 56;
    pnlKAKE.Caption := 'pnlKAKE';
    pnlKAKE.ChildOrder := 2;
    pnlKAKE.ShowCaption := False;
    btnKA.SetParentComponent(pnlKAKE);
    btnKA.Name := 'btnKA';
    btnKA.Left := 4;
    btnKA.Top := 3;
    btnKA.Width := 150;
    btnKA.Height := 48;
    btnKA.Caption := 'Arztgang-Anfang';
    btnKA.Color := clNone;
    btnKA.Glyph.LoadFromFile('UClockInForm.pnlKAKE.btnKA.Glyph.png');
    btnKA.GlyphSize := 32;
    btnKA.HeightPercent := 100.000000000000000000;
    btnKA.WidthPercent := 100.000000000000000000;
    SetEvent(btnKA, Self, 'OnClick', 'clockInButtonClick');
    btnKE.SetParentComponent(pnlKAKE);
    btnKE.Name := 'btnKE';
    btnKE.Left := 160;
    btnKE.Top := 3;
    btnKE.Width := 150;
    btnKE.Height := 48;
    btnKE.Caption := 'Arztgang-Ende';
    btnKE.Color := clNone;
    btnKE.Glyph.LoadFromFile('UClockInForm.pnlKAKE.btnKE.Glyph.png');
    btnKE.GlyphSize := 32;
    btnKE.HeightPercent := 100.000000000000000000;
    btnKE.WidthPercent := 100.000000000000000000;
    SetEvent(btnKE, Self, 'OnClick', 'clockInButtonClick');
    tmrClock.SetParentComponent(Self);
    tmrClock.Name := 'tmrClock';
    SetEvent(tmrClock, Self, 'OnTimer', 'tmrClockTimer');
    tmrClock.Left := 336;
    tmrClock.Top := 424;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    lblDate.AfterLoadDFMValues;
    lblTime.AfterLoadDFMValues;
    cbbClockIn.AfterLoadDFMValues;
    btnClockIn.AfterLoadDFMValues;
    pnlFak.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    cbbFak.AfterLoadDFMValues;
    edtFakFind.AfterLoadDFMValues;
    pnlTaet.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    cbbTaet.AfterLoadDFMValues;
    edtTaetFind.AfterLoadDFMValues;
    pnlKst.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    cbbKst.AfterLoadDFMValues;
    edtKstFind.AfterLoadDFMValues;
    pnlMat.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    cbbMat.AfterLoadDFMValues;
    edtMenge.AfterLoadDFMValues;
    pnlData1.AfterLoadDFMValues;
    lblDate1.AfterLoadDFMValues;
    lblTime1.AfterLoadDFMValues;
    pnlKOGE.AfterLoadDFMValues;
    btnKO.AfterLoadDFMValues;
    btnGE.AfterLoadDFMValues;
    pnlPAPE.AfterLoadDFMValues;
    btnPA.AfterLoadDFMValues;
    btnPE.AfterLoadDFMValues;
    pnlDADE.AfterLoadDFMValues;
    btnDA.AfterLoadDFMValues;
    btnDE.AfterLoadDFMValues;
    pnlKAKE.AfterLoadDFMValues;
    btnKA.AfterLoadDFMValues;
    btnKE.AfterLoadDFMValues;
    tmrClock.AfterLoadDFMValues;
  end;
end;

end.
